<div class="sigma_footer-middle">
    <div class="container">
        <div class="row">
            <div class="col-xl-4 col-lg-4 col-md-8 col-sm-12 footer-widget">
                <h5 class="widget-title"> {{ 'about' | translate }} </h5>
                <p class="mb-4"> {{'about_us_description' | translate}} </p>
                <div class="d-flex align-items-center justify-content-md-start justify-content-center mt-2">
                    <i class="far fa-envelope custom-primary me-3"></i>
                    <span>admin@frbishoykamel.org</span>
                </div>
                <div class="d-flex align-items-center justify-content-md-start justify-content-center mt-2">
                    <i class="far fa-map-marker custom-primary me-3"></i>
                    <span>126 Omar Lotfy، street, Al Ibrahimeyah Bahri WA Sidi Gaber, Bab Sharqi, 21524, Alexandria Egypt</span>
                </div>
            </div>
            <div class="col-xl-4 col-lg-4  col-sm-12 d-none d-lg-block footer-widget">
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 d-lg-block footer-widget widget-recent-posts">
                <h5 class="widget-title"> {{'our_app' | translate}} </h5>
                <div class="">
                    <a class="app-store_link" href="https://apps.apple.com/kw/app/father-bishoy-kamel/id1672284743" target="_blank">
                        <img src="assets/img/app-store.svg" [alt]="'app_store_link' | translate">
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=de.pharossolutions.frbishoykamel" target="_blank">
                        <img src="assets/img/google-play.svg" [alt]="'google_play_link' | translate">
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="sigma_footer-bottom">
    <div class="container-fluid">
        <div class="sigma_footer-copyright">
            <p> {{'copyrights' | translate}} <a class="text-white">{{currentYear}}</a> </p>
        </div>
        <ul class="sigma_sm square">
            <li>
                <a href="https://bit.ly/facebookfrbishoy" target="_blank">
                    <i class="fab fa-facebook-f"></i>
                </a>
            </li>
            <li>
                <a href="https://www.instagram.com/abounabishoykamel/" target="_blank">
                    <i class="fab fa-instagram"></i>
                </a>
            </li>
            <li>
                <a href="https://soundcloud.com/user-98965072" target="_blank">
                    <i class="fab fa-soundcloud"></i>
                </a>
            </li>
            <li>
                <a href="https://www.youtube.com/@fr.bishoy-kamel4770" target="_blank">
                    <i class="fab fa-youtube"></i>
                </a>
            </li>
        </ul>
    </div>
</div>